import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=371a780a&scoped=true&"
import script from "./ContactCard.vue?vue&type=script&lang=js&"
export * from "./ContactCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=371a780a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a780a",
  null
  
)

export default component.exports